<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import { eventBus } from '@/event_bus'
import Input from '@/components/Utils/Input.vue'
import NewColorPicker from '@/components/Utils/NewColorPicker.vue'

export default {
  name: 'Carousel',
  components: { NewColorPicker, Input },
  props: {
    vid: {
      type: String,
      default: '',
    },
    init_step_historys: {
      type: Array,
      default: () => [],
    },
    init_step_history_index: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      step_history: this.init_step_historys,
      step_history_index: this.init_step_history_index,
      mode: '',
      selected_location: null,
      controlled_carousel_id: '',
      carousel_editor_data: {},
      expansion_panel_title: {
        items: '項目',
        settings: '設定',
      },
    }
  },
  computed: {
    toolbox_title_btn() {
      return [
        {
          icon: 'mdi-arrow-u-left-top',
          disabled: this.step_history_index < 0,
          onclick: () => this.nextOrPrevious('previous'),
        },
        {
          icon: 'mdi-arrow-u-right-top',
          disabled: this.step_history_index === this.step_history.length - 1,
          onclick: () => this.nextOrPrevious('next'),
        },
      ]
    },
    ...mapGetters('optimize', [
      'activate_editor',
      'catch_iframe_selected_data',
      'catch_iframe_carousel_data',
      'send_iframe_post_message_data',
      'sdk_carousel_new_id',
      'carousel_previous_data',
    ]),
  },
  watch: {
    catch_iframe_selected_data: {
      handler(new_val) {
        // 點擊行為防呆
        if (!new_val.update_result && this.mode === 'edit') {
          if (!this.$refs.form.validate()) {
            return this.$root.vtoast.show({
              message: '請輸入網址或內嵌以利後續操作',
              color: 'error',
            })
          }
        }

        // 先初始化渲染畫面的資料
        this.initCarouselEditorData()
        const can_create_elements = ['DIV', 'IMG', 'P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']
        if (new_val.update_result?.carousel_data || new_val.carousel_data) {
          this.getCarouselData(new_val.update_result?.carousel_data || new_val.carousel_data)
          this.mode = 'edit'
          this.selected_location = new_val.update_result?.carousel_data.selector || new_val.carousel_data?.selector
        } else if (
          can_create_elements.includes(new_val.selected_element_info.nodeName) &&
          new_val.selected_element_info.parentNodeName === 'DIV'
        ) {
          this.mode = 'create'
          this.selected_location = new_val.selected_element_selector
        } else {
          this.mode = ''
        }
      },
    },
    send_iframe_post_message_data: {
      handler(new_val) {
        // 上下一步操作、預覽不存資料
        if (!new_val.is_history_step && !new_val.data.payload.is_preview) {
          const step_data = new_val
          step_data.data.payload.previous_data = JSON.parse(JSON.stringify(this.carousel_previous_data))

          // 存檔
          this.step_history.splice(
            this.step_history_index + 1,
            this.step_history.length - 1 - this.step_history_index,
            step_data
          )
          this.step_history_index = this.step_history.length - 1
        }

        eventBus.$emit('update-header-history', this.step_history, this.step_history_index)
      },
      deep: true,
    },
  },
  methods: {
    initCarouselEditorData() {
      this.carousel_editor_data = {
        items: [],
        settings: {
          model_size: {
            title: '輪播大小',
            width: {
              type: 'input',
              input_type: 'number',
              value: 0,
              label: '寬',
              width: 48,
              fn: this.editCarouselSize,
            },
            height: {
              type: 'input',
              input_type: 'number',
              value: 0,
              label: '高',
              width: 48,
              fn: this.editCarouselSize,
            },
          },
          next_and_prev: {
            title: '換頁',
            status: {
              type: 'select',
              label: '狀態',
              value: false,
              width: 48,
              select_list: [
                { text: '開', value: true },
                { text: '關', value: false },
              ],
              fn: this.preAndNextShow,
            },
            color: {
              type: 'color_picker',
              value: '',
              label: '按鈕顏色',
              width: 48,
              fn: this.preAndNextColor,
            },
          },
          pagination: {
            title: '分頁',
            status: {
              type: 'select',
              label: '狀態',
              value: false,
              width: 48,
              select_list: [
                { text: '開', value: true },
                { text: '關', value: false },
              ],
              fn: this.paginationShow,
            },
            color: {
              type: 'color_picker',
              value: '',
              label: '按鈕顏色',
              width: 48,
              fn: this.paginationColor,
            },
          },
          slides: {
            title: '分鏡',
            per_view: {
              type: 'select',
              label: '數量',
              value: 1,
              width: 48,
              select_list: [
                { text: 1, value: 1 },
                { text: 2, value: 2 },
                { text: 3, value: 3 },
              ],
              fn: this.editSlidesPerView,
            },
          },
          autoplay: {
            title: '自動播放',
            status: {
              type: 'select',
              label: '狀態',
              value: false,
              width: 48,
              select_list: [
                { text: '開', value: true },
                { text: '關', value: false },
              ],
              fn: this.autoplaySetting,
            },
            delay: {
              type: 'input',
              input_type: 'number',
              value: 0,
              label: '間隔秒數',
              width: 48,
              fn: this.autoplaySetting,
            },
          },
          delete: {
            title: '刪除輪播',
            delete: {
              type: 'btn',
              label: '刪除',
              color: 'error',
              fn: this.delete,
            },
          },
        },
      }
    },
    createCarousel(seat) {
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'create',
            selector: this.selected_location,
            carousel_id: this.sdk_carousel_new_id,
            seat,
          },
        },
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    itemFormat(item, index) {
      const https_regex = new RegExp('https://', 'i')
      return {
        title: `項目-${index + 1}`,
        width: {
          type: 'input',
          input_type: 'number',
          label: '寬',
          value: item.width,
          width: 31,
          disable: !item.item_url,
          fn: this.editItemStyle,
          rule: (val) => {
            return (0 < val && val <= 100) || '請輸入 1 ~ 100'
          },
        },
        height: {
          type: 'input',
          input_type: 'number',
          label: '高',
          value: item.height,
          width: 31,
          disable: !item.item_url,
          fn: this.editItemStyle,
          rule: (val) => {
            return (0 < val && val <= 100) || '請輸入 1 ~ 100'
          },
        },
        background: {
          type: 'color_picker',
          label: '底色',
          value: item.background,
          width: 31,
          disable: !item.item_url,
          fn: this.editItemStyle,
        },
        item_url: {
          type: 'input',
          input_type: 'text',
          value: item.item_url,
          label: '網址或內嵌',
          fn: this.editItem,
          rule: (val) => {
            return https_regex.test(val) || '格式錯誤'
          },
          width: 100,
        },
        link_url: {
          type: 'input',
          input_type: 'text',
          value: item.link_url,
          label: '連結',
          fn: this.editItem,
          disable: item.node_name === 'IFRAME',
          rule: (val) => {
            if (!val) {
              return true
            }
            return https_regex.test(val) || '格式錯誤'
          },
          width: 100,
        },
        delete: { type: 'btn', icon: 'mdi-minus-circle', color: 'error', fn: this.removeItem },
      }
    },
    getCarouselData(new_data) {
      this.controlled_carousel_id = new_data.carousel_id
      // items block
      this.carousel_editor_data.items = new_data.items.map((item, index) => this.itemFormat(item, index))

      // settings block
      for (const [row_key, row_value] of Object.entries(new_data)) {
        if (!['items', 'operate', 'carousel_id', 'carousel_new_id', 'selector'].includes(row_key)) {
          for (const [element_key, element_value] of Object.entries(row_value)) {
            this.carousel_editor_data.settings[row_key][element_key].value = element_value
          }
        }
      }
    },
    addItem() {
      this.carousel_editor_data.items.push(this.itemFormat({}, this.carousel_editor_data.items.length))
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'add_item',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
          },
        },
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    removeItem(new_data) {
      const item_id = new_data.row_index
      this.carousel_editor_data.items.splice(item_id, 1)
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'remove_item',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
            item_id,
          },
        },
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    editItem(new_data) {
      const row = new_data.row,
        item_id = new_data.row_index,
        e = new_data.$event

      const value_slot = {
        ['網址或內嵌']: (new_val) => (row.item_url.value = new_val),
        ['連結']: (new_val) => (row.link_url.value = new_val),
      }
      value_slot[e.label](e.value)

      if (!row.item_url.value) {
        this.$nextTick(() => {
          row.link_url.value = ''
        })
        this.$root.vtoast.show({
          message: '請先輸入網址',
          color: 'error',
        })
        return
      }

      const iframe_domain_regex = new RegExp('/www.instagram.com|www.facebook.com|www.threads.net/', 'i')
      if (iframe_domain_regex.test(row.item_url.value)) {
        row.link_url.disable = true
        row.link_url.value = ''
      } else {
        row.link_url.disable = false
      }

      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'edit_item',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
            item_id,
            item_url: row.item_url.value,
            link_url: row.link_url.value,
          },
        },
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    editItemStyle(new_data) {
      const row = new_data.row,
        row_index = new_data.row_index,
        e = new_data.$event

      const value_slot = {
        ['高']: (new_val) => (row.height.value = new_val),
        ['寬']: (new_val) => (row.width.value = new_val),
        ['底色']: (new_val) => (row.background.value = new_val),
      }
      value_slot[e.label](e.value)

      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'edit_item_style',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
            color: row.background.value,
            item_id: row_index,
            width: row.width.value,
            height: row.height.value,
          },
        },
      }
      if (e.is_preview) {
        post_msg_data.data.payload.is_preview = true
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    paginationShow(new_data) {
      const item = new_data.row
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'pagination_show',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
            status: item.status.value,
          },
        },
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    paginationColor(new_data) {
      const item = new_data.row,
        e = new_data.$event

      item.color.value = e.value
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'pagination_color',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
            color: item.color.value,
          },
        },
      }
      if (e.is_preview) {
        post_msg_data.data.payload.is_preview = true
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    preAndNextShow(new_data) {
      const item = new_data.row
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'pre_and_next_show',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
            status: item.status.value,
          },
        },
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    preAndNextColor(new_data) {
      const item = new_data.row,
        e = new_data.$event

      item.color.value = e.value
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'pre_and_next_color',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
            color: item.color.value,
          },
        },
      }
      if (e.is_preview) {
        post_msg_data.data.payload.is_preview = true
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    autoplaySetting(new_data) {
      const item = new_data.row,
        e = new_data.$event

      if (e) {
        item.delay.value = e.value
      }
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'autoplay_switch',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
            status: item.status.value,
            delay: item.delay.value,
          },
        },
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    editCarouselSize(new_data) {
      const item = new_data.row,
        e = new_data.$event

      e.label === '高' ? (item.height.value = e.value) : (item.width.value = e.value)
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'edit_carousel_size',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
            width: item.width.value,
            height: item.height.value,
          },
        },
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    editSlidesPerView(new_data) {
      const item = new_data.row
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'edit_slides_per_view',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
            amount: item.per_view.value,
          },
        },
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    delete() {
      const post_msg_data = {
        action: 'carousel',
        data: {
          vid: this.vid,
          type: 'next',
          payload: {
            type: 'carousel',
            operate: 'delete',
            selector: this.selected_location,
            carousel_id: this.controlled_carousel_id,
          },
        },
      }
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
    nextOrPrevious(next_or_previous) {
      const post_msg_data = { is_history_step: true }
      if (next_or_previous === 'next') {
        this.step_history_index++
        Object.assign(post_msg_data, JSON.parse(JSON.stringify(this.step_history[this.step_history_index])))
        // post_msg_data.data.type = 'next'
      } else if (next_or_previous === 'previous') {
        Object.assign(post_msg_data, JSON.parse(JSON.stringify(this.step_history[this.step_history_index])))
        // post_msg_data.data.type = 'previous'
        this.step_history_index--
      }
      if (post_msg_data.data) {
        post_msg_data.data.type = next_or_previous
      } else {
        post_msg_data.data = JSON.parse(JSON.stringify(post_msg_data))
        post_msg_data.type = next_or_previous
      }
      console.log('post_msg_data', post_msg_data)
      store.commit('optimize/SEND_IFRAME_POST_MESSAGE_DATA', post_msg_data)
    },
  },
}
</script>

<template>
  <v-card class="element-sort-toolbox" :width="400" :min-height="100">
    <v-card-title class="title primary justify-end px-3 py-0">
      <v-btn
        v-for="(btn_info, index) in toolbox_title_btn"
        :key="index"
        text
        icon
        :disabled="btn_info.disabled"
        @click="btn_info.onclick()"
      >
        <v-icon color="white" :size="20" v-text="btn_info.icon" />
      </v-btn>
    </v-card-title>
    <template v-if="mode === 'create'">
      <v-card-text class="pt-4 d-flex justify-space-around">
        <v-btn color="primary" @click="createCarousel('before')" v-text="'向上插入 Carousel'" />
        <v-btn color="primary" @click="createCarousel('after')" v-text="'向下插入 Carousel'" />
      </v-card-text>
    </template>

    <template v-else-if="mode === 'edit'">
      <v-card-text class="pa-0">
        <v-form ref="form" class="d-flex justify-center">
          <v-expansion-panels class="carousel-editor">
            <v-expansion-panel v-for="(panel_key, panel_index) in Object.keys(carousel_editor_data)" :key="panel_index">
              <v-expansion-panel-header>{{ expansion_panel_title[panel_key] }}</v-expansion-panel-header>
              <v-expansion-panel-content class="overflow-x-hidden" eager>
                <div v-for="(row, row_index) in carousel_editor_data[panel_key]" :key="row_index" class="rows">
                  <p class="ma-0 px-2 py-1 rows_title" v-text="row.title" />
                  <div class="d-flex pa-2 justify-space-between flex-wrap" style="gap: 8px">
                    <template v-for="(element, element_key) in Object.values(row)">
                      <Input
                        v-if="element.type === 'input'"
                        :key="element_key"
                        :type="element.input_type"
                        :value="element.value"
                        :label="element.label"
                        :disabled="element.disable"
                        :width="element.width"
                        :rules="[element.rule ? element.rule : true]"
                        @update-input="element.fn({ row, row_index, $event })"
                      />
                      <v-btn
                        v-if="element.type === 'btn'"
                        :key="element_key"
                        :icon="element.icon ? true : false"
                        :color="element.color"
                        @click="element.fn({ row, row_index })"
                      >
                        <template v-if="element.label">{{ element.label }}</template>
                        <v-icon v-else>{{ element.icon }}</v-icon>
                      </v-btn>
                      <v-select
                        v-if="element.type === 'select'"
                        :key="element_key"
                        v-model="element.value"
                        dense
                        outlined
                        hide-details
                        :style="`width: ${element.width}%`"
                        :items="element.select_list"
                        :label="element.label"
                        @change="element.fn({ row })"
                      />
                      <NewColorPicker
                        v-if="element.type === 'color_picker'"
                        :key="element_key"
                        :label="element.label"
                        :props-input-value="element.value"
                        :width="element.width"
                        :disabled="element.disable"
                        @update-color="element.fn({ row, row_index, $event })"
                      />
                    </template>
                  </div>
                </div>
                <div class="pa-2" style="border-top: 1px solid #eeeeee">
                  <v-btn v-if="panel_key === 'items'" icon color="primary" @click="addItem()">
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-form>
      </v-card-text>
    </template>

    <template v-else>
      <v-card-text>
        <p class="mt-3 mb-0 text-center" v-text="'請先選擇要建立的位置，若可建立將出現建立按鈕'" />
      </v-card-text>
    </template>
  </v-card>
</template>

<style lang="scss">
.element-sort-toolbox {
  user-select: none;
  .title {
    height: 50px;
  }
  .carousel-editor {
    .v-expansion-panel-header {
      font-size: 16px;
      font-weight: 500;
    }
    .v-expansion-panel-content {
      max-height: 450px;
      .v-expansion-panel-content__wrap {
        padding: 0;
        .rows {
          border-top: 1px solid #eeeeee;
          .rows_title {
            font-weight: 500;
            font-size: 13px;
            color: rgba(0, 0, 0, 0.4);
          }
          .v-input {
            flex: none;
          }
        }
      }
    }
  }
}
</style>
